import { useEffect } from "react";
import axiosInstance, { setupInterceptors } from "./axiosInstance";
import { useFlashMessage } from "../components/flashMessage/FlashMessageContext";
import { useAuth } from "../auth/AuthProvider";

const useAxiosInterceptors = () => {
  const { addMessage } = useFlashMessage();
  const { logout } = useAuth();

  useEffect(() => {
    const interceptor = setupInterceptors(addMessage, logout);

    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [addMessage, logout]);
};

export default useAxiosInterceptors;
